import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AppTranslateService } from 'src/app/service/core/app-translate.service';
import { UserProfileService } from 'src/app/service/userProfile.service';
import { HelperService } from '../helper.service';


@Component({
  selector: 'app-mobile-menu',
  templateUrl: './mobile-menu.component.html',
  styleUrls: ['./mobile-menu.component.css']
})
export class MobileMenuComponent extends HelperService implements OnInit {
  navigationArray: any[];
  userProfile: any = null;
  lang: string = null;
  constructor(private router: Router,
    private appTranslateService: AppTranslateService,
    private userProfileService: UserProfileService,) {
    super();
    this.userProfile = this.userProfileService.getProfile();


    this.lang = appTranslateService.getCurrentLang();

    this.navigationArray = [
      {
        "id": 1,
        "link": "/",
        "linkText": "homePage"
      },
      {
        "id": 2,
        "linkText": "services",
        "child": true,
        "submenu": [
          {
            "id": 1.1,
            "link": "/customer/requestService/1",
            "linkText": "legalNotification"
          },
          {
            "id": 1.2,
            "link": "/customer/requestService/2",
            "linkText": "publishing"
          }
        ]
      },
      {
        "id": 3,
        "link": "/",
        "linkText": "aboutUs"
      },
      {
        "id": 4,
        "link": "/",
        "linkText": "contactUs"
      },
    ];
  }

  ngOnInit(): void {
    this.router.events.subscribe((evt) => {

      if (evt instanceof NavigationStart) {
        this.userProfile = this.userProfileService.getProfile();
      }
    });
  }



  changeLanguage() {
    if (this.lang === 'ar') {
      localStorage.setItem("lang", "en");
    } else {
      localStorage.setItem("lang", "ar");
    }
    location.reload();
  }

  goToDiv(divId) {

    var isNotHome = false;
    if (this.router.url !== "/") {
      this.router.navigate(["/"]);
      isNotHome = true;;
    }
    const firstElementWithError = document.querySelector('#' + divId);

    if (firstElementWithError) {
      if (isNotHome === true) {
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $(firstElementWithError).offset().top - 100
          }, 1000);
        }, 2000);

      } else {
        $('html, body').animate({
          scrollTop: $(firstElementWithError).offset().top - 100
        }, 1000);
      }
    }
    this.closeMobileMenu();
  }

  logout() {
    this.userProfileService.clearProfile();
    this.userProfile = null;
    this.router.navigate(["/account/login"]);
    this.closeMobileMenu();
  }

  closeMobileMenu() {
    setTimeout(() => {
      $("#closeIcon").click();
    }, 500);
  }
}
